import {createSlice} from "@reduxjs/toolkit";

export const callTypes = {
  list: "list",
  action: "action"
};

export const slice = createSlice({
  name: "supplements",
  initialState: {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    initEntities: [],
    entityForEdit: undefined,
    lastError: null,
    lang:"en"
  },
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    manyFetched: (state, action) => {
      const { totalCount, entities, lang } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    changeLang: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.lang = action.payload.lang;
    },
    fetched: (state, action) => {
      state.actionsLoading = false;
      state.entityForEdit = action.payload.entityForEdit;
      state.error = null;
    },
    init: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.initEntities = entities;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    created: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload._data);
      state.initEntities.push(action.payload._data);
    },
    updated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload._data.id) {
          return action.payload._data;
        }
        return entity;
      });
    },
    deleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
      state.initEntities = state.initEntities.filter(el => el.id !== action.payload.id);
    },
    manyDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    }
  }
});
